export function parseDetailsBlock(text: string): {
  details: string | null;
  cleanedText: string;
  isStreamingPartial: boolean;
} {
  const detailsRegex = /\[DETAILS\]([\s\S]*?)\[\/DETAILS\]/;
  const match = text.match(detailsRegex);
  if (match) {
    let cleanedText = text.replace(detailsRegex, '');
    cleanedText = cleanedText.replace(/\[DETAILS[-_A-Z]*$/i, '');

    return {
      details: match[1].trim(),
      cleanedText,
      isStreamingPartial: false,
    };
  }

  const openTagIndex = text.indexOf('[DETAILS]');
  if (openTagIndex >= 0) {
    const details = text.slice(openTagIndex + '[DETAILS]'.length).trim();
    const cleanedText = text.slice(0, openTagIndex).trimEnd();
    return {
      details: details.length > 0 ? details : null,
      cleanedText,
      isStreamingPartial: true,
    };
  }

  const cleanedText = text.replace(/\[DETAILS[-_A-Z]*$/i, '');
  return { details: null, cleanedText, isStreamingPartial: false };
}

export function formatDetailsForMarkdown(text: string): string {
  return text.replace(/\n/g, '  \n');
}
